import React from 'react';
import {Img} from "react-image";
import {
    useParams,
} from "react-router-dom";

import FormPage from '../FormPage';
import LoadingSpinner from "../../components/LoadingSpinner";
import TermsModal from '../../components/TermsModal';
import Modal from '../../components/Modal';

import Auth from '../../Auth';
import InternationPhoneInput from "../../components/form/InternationPhoneInput";
import {Divider} from "antd";
import SSOAuthorizationButtons from "../../components/SSOAuthorizationButtons";

const styles = {
    fieldSection: {
        flexDirection: 'row',
    },
    field: {
        padding: '0 15px',
        margin: '0 0 3px',
    },
};

class AuthRegistration extends FormPage
{
    static path = '/register/:token';

    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = 'client-register-form bordered-panel';

    /**
     * The title shown on the form
     */
    // static FormTitle = TB.isObject(laravel.registering_user)
    //     ? "clients.register_user.title"
    //     : 'clients.register_user.invalid_invite';

    static FormTitle = TB.isObject(laravel.registering_user)
        ? ""
        : 'clients.register_user.invalid_invite';

    /**
     * The subtitle shown on the form
     */
    // static FormSubtitle = "clients.register_user.subtitle";
    static FormSubtitle = "";

    /**
     * The submit button title for the form
     */
    static FormSubmit = TB.isObject(laravel.registering_user)
        ? "clients.register_user.submit_button"
        : false;

    /**
     * The api endpoint path that the form should send a post request to
     */
    static FormPost = "/api/sessions/register";

    /**
     * Custom Form Component Props
     *
     * @returns {Object}
     */
    formProps() {
        return {
            customValidate: () => this.isTermsValidated()
        }
    }

    isTermsValidated() {
        if (!this.state.accepted_terms) {
            TB.toast("Please agree to the terms & agreement before continuing.", {theme: 'danger'})
            return false
        }
        return true;
    }
    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 800;

    /**
     * The fields mapping for the form
     */
    static FormFields = !TB.isObject(laravel.registering_user) ? [] : [
        {
            style: styles.fieldSection,
            fields: {
                first_name: {
                    type: 'text',
                    label: 'clients.register_user.first_name_label',
                    columns: 6,
                    readOnly: !!laravel.registering_user.client_organization?.sso_provider,
                    disabled: !!laravel.registering_user.client_organization?.sso_provider,
                    style: styles.field,
                    labelClassName: 'p-0 pb-1 m-0',
                },
                last_name: {
                    type: 'text',
                    label: 'clients.register_user.last_name_label',
                    columns: 6,
                    readOnly: !!laravel.registering_user.client_organization?.sso_provider,
                    disabled: !!laravel.registering_user.client_organization?.sso_provider,
                    style: styles.field,
                    labelClassName: 'p-0 pb-1 m-0',
                },
            }
        },
        ...(
            laravel.registering_user.client_organization?.sso_provider ? [] : [
                {
                    style: styles.fieldSection,
                    fields: {
                        phone: {
                            label: 'clients.register_user.phone_label',
                            columns: 6,
                            type: 'antd-input',
                            children: (
                                <InternationPhoneInput/>
                            ),
                            required: false,
                            style: styles.field,
                            labelClassName: 'p-0 pb-1 m-0',
                        },
                        email: {
                            type: 'email',
                            label: 'clients.register_user.email_label',
                            columns: 6,
                            style: styles.field,
                            labelClassName: 'p-0 pb-1 m-0',
                        },
                    }
                },
                {
                    style: styles.fieldSection,
                    fields: {
                        job_title: {
                            type: 'text',
                            label: 'clients.register_user.job_title_label',
                            columns: 6,
                            required: false,
                            style: styles.field,
                            labelClassName: 'p-0 pb-1 m-0',
                        },
                    }
                },
                {
                style: styles.fieldSection,
                fields: {
                    password: {
                        type: 'password',
                        label: 'clients.register_user.password_label',
                        autoComplete: 'new-password',
                        columns: 6,
                        style: styles.field,
                        labelClassName: 'p-0 pb-1 m-0',
                    },
                    password_confirmation: {
                        type: 'password_confirmation',
                        label: 'clients.register_user.password_confirmation_label',
                        columns: 6,
                        style: styles.field,
                        labelClassName: 'p-0 pb-1 m-0',
                    },
                }
            }
]        )
    ];

    /**
     * The links mapping for the form
     */
    // static FormLinks = [
    //     {
    //         title: 'clients.register_user.login_link',
    //         path: '/login',
    //         columns: 12
    //     }
    // ];

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props)
    {
        super(props);

        let user = laravel.registering_user || {};
        this.modalRef = React.createRef();
        let model = {...user};
        if (model.phone) {
            let phoneNumber = model.phone.replace(/\D/g, '');
            if (phoneNumber?.length === 10 && !model.phone.includes('+')) {
                model.phone = "+1 " + model.phone;
            }
        }
        this.state = {
            ...this.state,
            model,
            accepted_terms: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        if (laravel.oauth_error === 'No user found'
            || laravel.oauth_error === 'Email mismatch') {

            TB.alert('error',
                'Something went wrong.',
                'There was an error while trying to authenticate you. ' +
                'The email matched with your SSO Provider does not match the registration token. Please try again or contact your administrator for assistance.',
                [{title: 'Ok'}]);

            laravel.oauth_error = null;
        }
    }

    /**
     * Maps form input data to form submit model
     * Appends token to form data from url route parameter
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model)
    {
        model.token = this.props.token;

        return model;
    }

    formSubmit() {
        return false;
    }

    /**
     * Renders form child elements
     *
     * @returns {Component}
     */
    renderFormChildren()
    {
        if (!TB.isObject(laravel.registering_user)) {
            return <div/>;
        }

        const {
            client_organization,
            client_organizations,
        } = laravel.registering_user;

        let clientOrgName = client_organization?.name;
        if (!clientOrgName && client_organizations?.length > 0) {
            clientOrgName = client_organizations[0]?.name;
        }

        return (
            <div className="registration-form-children">

                <p className="register-terms">Terms & Agreement</p>
                <p>
                    {clientOrgName ? `${clientOrgName} is` : 'You are'} under contract with Wripple. Here are the key terms that you, as an employee of {clientOrgName || 'Wripple'}, must acknowledge before your Wripple registration is complete:
                </p>

                <ul className="list-disc pt-4">
                    <li>
                        I will keep Confidential any information specifically on the Wripple platform related to candidate profiles, rates and contracts.
                    </li>
                    <li>
                        I agree that I will only contract, contract-to-hire, hire or attempt to hire talent found on the Wripple platform through Wripple.
                    </li>
                </ul>

                <div className="form-checkbox">

                    <input type="checkbox"
                        disabled={this.props.disabled}
                        className="form-check-input"
                        id="terms-checkbox"
                        name="terms-checkbox"
                        onChange={event => {
                            this.setState({
                                accepted_terms: !this.state.accepted_terms
                            })
                        }}
                    />

                    <label className="form-check-label" htmlFor="terms-checkbox">
                        {/* {TB.trans('talent.basic_info.terms_agreement_check_label')}&nbsp; */}
                        I have read and agreed to the&nbsp;
                        <span className="btn-link btn-link-primary" onClick={e => {
                            e.preventDefault();
                            this.modalRef.current.showModal({
                                title: 'Marketplace Terms of Use',
                                defaultScroll: false
                            })
                        }}>
                            {/* {TB.trans('talent.basic_info.terms_agreement_check_label_link')} */}
                           terms of service
                        </span>
                    </label>

                </div>

                {laravel.registering_user.client_organization?.sso_provider ? (
                    <div className="flex flex-col items-center gap-6 mt-4">
                        <p className="italic font-semibold">
                            Your organization requires you to use an external identity provider to log in.
                            Please use the following link to log in with your organization's SSO provider.
                        </p>
                        <SSOAuthorizationButtons
                            registration={true}
                            disabled={false}
                            loginText={"Login with "}
                            validateBeforeSubmit={() => this.isTermsValidated()}
                        />
                    </div>
                ) : (
                    <button type="submit" className="btn btn-primary mt-3">Create My Account</button>
                )}


                <Modal ref={this.modalRef}>
                    <TermsModal userType="client" onClose={() => this.modalRef.current.hideModal()}/>
                </Modal>

            </div>
        );
    }

    renderFormFooter() {
        return (
            <div style={{ background: 'red' }}>
                hello from footer
            </div>
        )
    }

    renderFormView() {
        if(!laravel.registering_user) {
            return (
                <div className="container mx-auto p-5">
                    <div className="flex flex-row justify-center">
                        <div className="basis-1/2">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="registration-container">

                <div className="md:flex justify-between">
                    <div className="w-full md:w-5/12 lg:w-6/12 xl:w-5/12">

                        <Img
                            loader={(
                                <div className={`self-stretch justify-center items-center flex flex-col`}>
                                    <LoadingSpinner/>
                                </div>
                            )}
                            src={[TB.logoBrandImagePath(), '/images/logo.png']}
                            className="pb-3 registration-logo"
                        />
                        <h1 className="text-primary">{TB.tryTrans('clients.register_user.subtitle')}</h1>
                        <h3 className="pb-4 pr-2">{TB.tryTrans('clients.register_user.title')}</h3>
                        <div className="hidden md:flex px-2">
                            <img className="registration-login-graphic" src="/images/bicycle-gray-bg.gif " alt={`Welcome to ${laravel.platform_name}`}/>
                        </div>
                    </div>

                    <div className="w-full md:w-7/12 lg:w-6/12 xl:w-6/12">

                        {this.renderForm()}

                    </div>
                </div>
            </div>
        )
    }

    /**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
    onSuccess(responseData)
    {
        let needs2FA = Auth.checkResponseRequires2FA(responseData)
        if (needs2FA) {
            return;
        }

        Auth.update({...responseData.data.auth});
    }
}

export default () => {
    const {token} = useParams();
    return (
        <AuthRegistration token={token} />
    )
}